export default __webpack_public_path__ + "static/media/d8a530f261f92406.c0fc306c0e8cad2140b78dea9bdac808.svg";